<template>
  <div class="evaluation">
    <div class="col-md-12 eval-top">
        <div class="pms-review-header-section">
            <div class="pms-header-title" @click="currentTab = 'Evaluation'"
                :class="currentTab == 'Evaluation' ? 'active-header' : 'inactive-header'">
                Evaluation
            </div>
            <div class="pms-header-title" @click="currentTab = 'PerformanceReview'"
                :class="currentTab == 'PerformanceReview' ? 'active-header' : 'inactive-header'">
                Performance Review
            </div>
        </div>
    </div>
  <div v-if="currentTab == 'Evaluation'">
    <div v-if="$route.name == 'employee-evaluation-trainee'" class="row" style="padding-bottom:10px;">
      <div class="col-md-6">
        <h4 class="header">EVALUATION</h4><span class="span-color">{{count}}</span>
      </div>
      <div class="col-md-6 text-right">
        <div class="generate">

          <ob-button v-if="IsReportGenerationInProgress" :disabled="IsReportGenerationInProgress" type="secondary" @click="generateReport()">
                            <span v-if="IsReportGenerationInProgress" v-tooltip="'Timesheets report generation is in-progress so please wait till it is completed.'">Generate Evaluation Report</span>
                            <span v-else>Generate Evaluation Report</span>
          </ob-button>
          <ob-button v-else type="secondary" :disabled="enableGenerateReport" @click="generateReport()">Generate Evaluation Report</ob-button>
        </div>
      </div>
    </div>
    <div class="loader-class" v-if="isLoading">
      <ob-spinner loading-text="Loading..."></ob-spinner>
    </div>
    <div v-else-if="evaluationList && (evaluationList.length) > 0">
      <div v-for="(item ,index) in evaluationList" style="border-bottom: 1.5px dashed rgb(212, 204, 204);">
        <div class="row" style="margin:14px;">
          <span style="color:#333333;margin-right: 5px;font-weight:700;text-transform: capitalize;font-size:14px;">{{getlistByMonth(item[0].FromDate)}}</span>
        </div>
        <div class="row" v-for="list in item" style="margin-left: 14px;;margin-right: 10px;">
          <ob-collapse :type="7" :expand="false" :disabled="false" theme="default">
            <template slot="collapse-title">
              <ul class="clearfix list-unstyled list-inline">
                <li>
                  <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendar.svg`" style="margin-right: 10px;"/><span style="color:#333333;margin-right: 5px;text-transform: capitalize;font-size: 13px;width: 88px;display: inline-block;">{{list.Name}}</span>
                  <span style="color:#8595A6;font-size: 11px;width: 238px;display: inline-block;">{{getDateFormat(list.FromDate)}} to {{getDateFormat(list.ToDate)}}</span>
                  <span v-if="$route.name == 'evaluation'"><span :class="(list.Status == 'Approved' && list.EvaluationStatus == 'Approved') ? 'circle' : 'circle1'"></span><span style="font-weight:600;">{{getStatus(list)}}</span></span>
                  <span style="margin-left: 60px;" v-else><span :class="(list.Status == 'Approved' && list.EvaluationStatus == 'Approved') ? 'circle' : 'circle1'"></span><span style="font-weight:600;">{{getStatus(list)}}</span></span>
                </li>
              </ul>
            </template>
            <template slot="collapse-title-right">
              <span v-if="$route.name == 'evaluation'">
                <span style="width:56px;font-weight: 600;display:inline-block;float: left;">{{list.NoofDays}} Day(s)</span>
                <ul class="clearfix list-unstyled list-inline" style="float: left;width:260px;">
                  <li style="margin-left:74px;"><li style="padding:0px;" v-if="list.Status != 'Rejected'"><div v-if="IsEditTimesheet && list.QBInvoiceId == ''" style="margin-top: -5px;"><span class="edit" @click="editTimesheet(list.Id,index)"><i class="fa fa-pencil img" aria-hidden="true" ></i></span></div></li>
                  <li style="padding:0px;" v-if="list.Status != 'Rejected'"><div v-if="list.QBInvoiceId == ''" style="margin-top: -5px;"><span class="delete" @click="deleteReport(list.Id,index)"><i class="fa fa-trash img" aria-hidden="true" ></i></span></div></li>
                  <li style="margin-right:2px;float:right;margin-top:5px;" v-if="list.Status == 'Approved' && list.EvaluationStatus == 'Approved'"><div style="margin-top: -5px;"><ob-button @click="viewReport(list.Id,index)" style="width:94px!important" >View Report</ob-button></div></li>
                </ul>
              </span>
              <span v-else>
                <span style="width:56px;font-weight: 600;display:inline-block;float: left;">{{list.NoofDays}} Day(s)</span>
                <ul class="clearfix list-unstyled list-inline" style="float: left;width:220px;">
                  <li style="margin-left:74px;"><div style="margin-top: -5px;"><span class="edit" v-if="(list.Status == 'Approved' && isSupervisor && list.IsEditEvaluation &&  list.EvaluationStatus == 'Approved')" @click="edit(list.Id,index)"><i class="fa fa-pencil img" aria-hidden="true" ></i></span></div></li>
                  <li style="margin-right:2px;float:right;margin-top:5px;" v-if="(isSupervisor && list.Status == 'Approved' && list.EvaluationStatus == 'Pending')"><div style="margin-top: -5px;"><ob-button @click="evaluate(list.Id,index)" style="width:94px!important">Evaluate</ob-button></div></li>
                  <li style="margin-right:2px;float:right;margin-top:5px;" v-else><div style="margin-top: -5px;"><ob-button @click="viewReport(list.Id,index)" style="width:94px!important">View Report</ob-button></div></li>
                </ul>
              </span>
            </template>
            <template slot="collapse-details">
              <div class="row">
                <div class="col-md-12" style="padding-bottom: 10px" v-if="list.LeaveList != null && list.LeaveList.length > 0">
                <span style="color: rgb(250, 100, 0);font-style: italic;font-size: 13px;font-weight: 600;"> Added a timesheet during an Approved leave period {{getLeaveRange(list.LeaveList)}}</span>
                </div>
                <div class="col-md-12 pL0">
                  <div class="col-md-3">
                    <label>Hours Worked</label>
                    <h5 class="evalution_details_values">{{list.HoursWorked}}</h5>
                  </div>
                  <div class="col-md-3" v-if="list.SubmittedDate != null && list.SubmittedDate != '' && (list.EvaluationStatus == 'Pending' || list.EvaluationStatus == 'Approved')">
                    <label>Submitted Date</label><span class="edit_date" v-if="list.IsEditSub && !list.IsEditApp" @click="updateDates(list)">Save</span>
                    <div v-if="list.IsEditSub"><ob-date-time-picker :id="'date4'+list.Id" :inputvalue="list.SubmittedDate" :options="subOptions(list)" @updated="(v) => list.SubmittedDate = v" v-model="list.SubmittedDate"></ob-date-time-picker></div>
                    <div v-else><h5 class="evalution_details_values">{{list.SubmittedDate}}<span @click="editSubmittedDate(list)" v-if="isSupervisor" style="padding-left: 6px;"><i class="fa fa-pencil image" aria-hidden="true" :class="{ 'editDisable': disableSubmitDateEdit(list)}"></i></span></h5></div>
                  </div>
                  <div class="col-md-3" v-if="list.EvaluationDate != null && list.EvaluationDate != '' && list.EvaluationStatus == 'Approved'">
                    <label>Evaluated Date</label><span class="edit_date" v-if="list.IsEditApp && !list.IsEditSub" @click="updateDates(list)">Save</span>
                    <div v-if="list.IsEditApp"><ob-date-time-picker :id="'date5'+list.Id" :inputvalue="list.EvaluationDate" :options="appOptions(list.ApprovedDate)" @updated="(v) => list.EvaluationDate = v" v-model="list.EvaluationDate"></ob-date-time-picker></div>
                    <div v-else><h5 class="evalution_details_values">{{list.EvaluationDate}}<span @click="editApprovedDate(list)" v-if="isSupervisor" style="padding-left: 6px;"><i class="fa fa-pencil image" :class="{ 'editDisable': disableApprovedDateEdit(list)}" aria-hidden="true" ></i></span></h5></div>
                  </div>
                  <div class="col-md-3">
                    <label>Project Title</label>
                    <h5 style="font-weight:600" class="project_title" v-if="list.ProjectTitle != null && list.ProjectTitle != ''" :title="list.ProjectTitle">{{list.ProjectTitle}}</h5>
                    <h5 style="font-weight:600" v-else>N/A</h5>
                  </div>
                  <div class="col-md-3" v-if="list.EvaluationStatus == 'Pending'">
                    <label>End-Client</label>
                    <h5 style="font-weight:600">{{NAOrValue(list, 'EndClientName')}}</h5>
                  </div>
                </div>
                <div class="col-md-12 pL0" v-if="list.EvaluationDate != null && list.EvaluationDate != '' && list.EvaluationStatus == 'Approved'">
                  <div class="col-md-3">
                    <label>End-Client</label>
                    <h5 style="font-weight:600">{{NAOrValue(list, 'EndClientName')}}</h5>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-12 pL0">
                <template v-for="(item,index) in list.Attachments">
                  <div class="attachments-view">
                    <template>
                      <span class="fileName">
                        {{item  | I9URL2FileName}}
                      </span>
                      <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div style="padding:10px;">
                                <span :class="{'cursorCls': !isFileType(item)}" >
                                  <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                                </span>
                                <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                                <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                            </div>
                        </div>
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                    </ob-popover>
                    </template>
                  </div>
                </template>
              </div>
              <div v-if="list.Reason != null && list.Reason != ''" class="row"  style="border-top: 1.5px dashed #d4cccc;margin-top:10px;">
                <div class="col-md-12" style="margin-top:15px;">
                  <label>Reason for Rejection</label>
                  <h5 style="font-weight:600">{{list.Reason}}</h5>
                </div>
              </div>
            </template>
          </ob-collapse>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="evaluation_empty">
        <div style="margin-bottom:20px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_evaluation-empty.svg`"/></div>
        <div style="font-size: 14px;margin-bottom:15px;">No evaluation reports to display.</div>
      </div>
    </div>
    <approval-report :iframeURL="iframeURL"  :CanEvaluate="CanEvaluate" @approved="approved"  :EmployeeId="EmployeeId" :selectedReport.sync="selectedReport" :evaluationId.sync="evaluationId" @openEvaluation="openEvaluation" :openModal.sync="openApprovalreport" :isSupervisor.sync="isSupervisor" ></approval-report>
    <evaluation-report @approved="approved" :EmployeeId="EmployeeId" :selectedReport.sync="selectedReport" :openModal.sync="openEvaluationReport" :EvaluationStatus="evaluationStatus"></evaluation-report>
    <!-- <generate-report :EmployeeId="EmployeeId" :show.sync="showgeneratePopup"></generate-report> -->
    <generate-evalution-report :EmployeeId ="EmployeeId" :show.sync="showgeneratePopup"></generate-evalution-report>
  </div>
  <div v-if="currentTab == 'PerformanceReview'">
    <performance-review></performance-review>
  </div>
  </div>
</template>
<script>
import ApprovalReport from '../Timesheets/ApprovalReport.vue'
import EvaluationReport from '../Timesheets/EvaluationReport.vue'
import CommonFunctionMixin from '../Timesheets/CommonFunctionMixin'
import utils from "Vue/Core/utils.js";
import PerformanceReview from './PerformanceReview/PerformanceReview.vue'

// import GenerateReport from '../Timesheets/GenerateReport.vue'
import GenerateEvalutionReport from '../Timesheets/GenerateEvalutionReport'
export default {
  mixins: [CommonFunctionMixin],
  props: ["consultantDetails","isSupervisor","evaluationCount"],
  data(){
    return{
      IsReportGenerationInProgress:false,
      isEdit: false,
      openApprovalreport:false,
      openEvaluationReport:false,
      showgeneratePopup : false,
      count:'',
      evaluationList:[],
      evaluationId:'',
      selectedReport:null,
      isLoading: true,
      IsEditTimesheet: false,
      CanEvaluate : true,
      iframeURL:'',
      options3: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
      },
      currentTab: 'Evaluation'
    }
  },
   mounted() {

    events.listen('IsTimesheetInProgress', (val) => {
      this.IsReportGenerationInProgress = val;
    })
  },
  computed: {
    evaluationStatus(){
      if(this.selectedReport != null && this.selectedReport != ''){
        return this.selectedReport.EvaluationStatus
      }
    },
    enableGenerateReport()
    {
      if(this.evaluationList.length > 0 && this.$route.name == 'employee-evaluation-trainee')
      {
        return false
      }
      else
      {
        return true
      }
    },
    EmployeeId() {
      if(this.$route.query.EmployeeId){
        return this.$route.query.EmployeeId
      }
      else
        return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    },
  },
  created(){
    let interval = setInterval(() => {
      clearInterval(interval);
      this.getEvaluation()
    }, 500);
    this.getIsEditTimesheet()
  },
  watch: {
    EmployeeId(val) {
      if(val != null && val != '')
      {
        this.getEvaluation()
      }
    },
    currentTab(val) {
      if(val == 'Evaluation') {
        if(this.EmployeeId != '' && this.EmployeeId != null){
          this.getEvaluation()
        }
      }
    }
  },

  components:{
    "approval-report":ApprovalReport,
    "evaluation-report": EvaluationReport,
    // "generate-report": GenerateReport
    "generate-evalution-report":GenerateEvalutionReport,
    "performance-review" : PerformanceReview
  },

  methods: {
    isFileType(item)
      {
        var filename = utils.I9URL2FileName(item);
        var fileExtention = filename.split('.').pop();
        var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
        return FileTypes.includes(fileExtention)
      },
    getLeaveRange(list)
    {
      var str = "";
      for(var i = 0 ; i< list.length ; i++)
      {
        if(list[i].FromDate == list[i].ToDate)
        {
          str = str + " "+ moment(list[i].FromDate).format('Do MMM') +", ";
        }
        else{
          str = str + " (" + moment(list[i].FromDate).format('Do MMM') + " to "+  moment(list[i].ToDate).format('Do MMM') +"), "
        }
      }
      return str.slice(0, -2);
    },
    getIsEditTimesheet(){
      this.$loading({'loadingText': 'Loading...'}) 
            ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
              if(res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval != null && res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval != undefined){
              this.IsEditTimesheet = res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval.PreferenceApplied
            }
              this.$loading({}).close()
            })
    },
    disableApprovedDateEdit(l){
      if(l.IsEditSub && !l.IsEditApp){
        return true
      }
      else{
        return false
      }
    },
    disableSubmitDateEdit(e){
      if(!e.IsEditSub && e.IsEditApp){
        return true
      }
      else{
        return false
      }
    },
    editSubmittedDate(list){
      if(!this.disableSubmitDateEdit(list)){
        list.IsEditSub = true
        list.IsEditApp = false
      }
    },
    editApprovedDate(list){
      if(!this.disableApprovedDateEdit(list)){
        list.IsEditSub = false
        list.IsEditApp = true
      }
    },
    subOptions(x)
    {
      var options = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        minDate: x.FromDate,
        maxDate: moment(),
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
      }
      let date = moment(x.ApprovedDate) < moment(x.EvaluationDate) ? x.ApprovedDate : x.EvaluationDate
       if(date != null && date != '')
       {
         options['maxDate'] = date
       }
      return options
    },
    appOptions(date)
    {
       var options = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        minDate: date,
        maxDate: moment(),
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
      }
      return options
    },
    generateReport()
    {
      this.showgeneratePopup = true
    },
    evaluate(id,index){
      this.selectedReport = this.evaluationList[index].find(v=>v.Id == id)
      this.openEvaluationReport = true
      this.isEdit = false
    },
    viewReport(id,index){
      this.iframeURL = '' ;
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.get(`/TimeSheets/${id}/CanEvaluate`, {} , (res) => {
        if(res.data.State == true) {
          var IsEvaluate = res.data.CanEvaluate
          this.selectedReport = this.evaluationList[index].find(v=>v.Id == id)
          ajax.get(`TimeSheets/Report/${this.selectedReport.TimesheetId}?employeeId=${this.selectedReport.EmployeeId}`, {} , (res) => {
            if(res.data.State == true){
              this.iframeURL = res.data.ReportUrl;
              if(IsEvaluate)
              {
                this.CanEvaluate = true
                this.openApprovalreport = true
                this.isEdit = false
                this.evaluationId = id
              }
              else
               {
                this.CanEvaluate = false
                this.openApprovalreport = true
                this.isEdit = false
                this.evaluationId = id
                }
                this.$loading({}).close()
                }
              })
          }
        })
     },
    canEvaluate(id)
    {
      var IsEvaluate = false
      ajax.get(`TimeSheets/${id}/CanEvaluate`, {} , (res) => {
        if(res.data.State == true) {
          IsEvaluate = res.data.CanEvaluate
        }
      })
      return IsEvaluate
    },
    editTimesheet(id,index){
      this.$loading({ 'loadingText': 'Loading...' })
      var routerPush = this.$router.resolve({name: `employee-addtimesheets` ,query: {TimesheetId: id , from : this.$route.name}})
      setTimeout(() => {
        this.$loading({}).close()
      }, 600)
      window.open(routerPush.href, "_self")
    },
    deleteReport(id,index){
      this.$alert2("Are you sure you want to Delete ?", "Alert", {
        type: "confirm",
        yesButtonText: "Yes",
        noButtonText: "No",
        callback: (action) => {
          if(action === true) {
           this.deleteTimesheet(id,index)
          }
        }
      });
    },
    deleteTimesheet(id,index){
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.put(`TimeSheets/Delete/Evaluation/${id}?employeeId=${this.EmployeeId}`,{},(res) => {
        if(res.data.State == true){
          this.getEvaluation()
          this.$message({
            type: 'success',
            message: "Evaluation Deleted Successfully"
          });
        }else{
          this.$message({
            type:'error',
            message: res.data.Message
          })
        }
        this.$loading({}).close()
      })
    },
    edit(id,index){
      this.selectedReport = this.evaluationList[index].find(v=>v.Id == id)
      this.openEvaluationReport = true
      this.isEdit = true
    },
    openEvaluation()
    {
      this.openEvaluationReport = true
    },
    approved(){
      this.getEvaluation()
      this.openEvaluationReport = false
      this.openApprovalreport = false
    },
    getEvaluation(){
      this.openEvaluationReport = false
      this.openApprovalreport = false
      this.isLoading = true
      ajax.get(`TimeSheets/Evaluation/List/${this.EmployeeId}`, {} ,(res) => {
        if(res.data.State == true){
          this.count = res.data.Count
          this.$emit('update:evaluationCount', this.count)
           var result =  res.data.EvaluationList;
          this.evaluationList = result;
        }
        this.isLoading = false
      })
    },
    updateDates(list){
      this.$loading({ 'loadingText': 'Saving...' })
      var status = list.IsEditSub ? 'Pending' : 'Approved';
      var date = list.IsEditSub ? list.SubmittedDate : list.EvaluationDate;
      ajax.put(`TimeSheets/UpdateTimeSheetDates/${list.Id}?date=${date}&status=${status}&isEvaluationTab=true&isTimesheetdate=true`, {}, (res) => {
        if(res.data.State == true){
          if(list.IsEditSub){
            list.IsEditSub = false
          }else{
            list.IsEditApp = false
          }
        }
        this.$loading({}).close()
      })
    },
    getDateFormat(date){
      var date1 = moment(date).format('Do');
      var month = moment(date).format('MMM');
      var year = moment(date).format('YYYY')
      return date1 +" "+ month +" "+ year
    },
    getlistByMonth(date){
      var month = moment(date).format('MMM');
      var year = moment(date).format('YYYY')
      return month +" "+ year
    },
    getStatus(list){
      if(list.Status == "Approved" && list.EvaluationStatus == "Approved"){
        return "Completed"
      }else{
        return "Incomplete"
      }
    }
  }
}
</script>
<style>
  .edit_date{
    float: right;
    font-style: italic;
    color: #4A90E2;
    font-weight: 600;
    cursor: pointer;
  }
  .evaluation{
    height: 90%;
    margin-top: 12px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .edit:hover,.delete:hover{
    background-color: #E8E8E9;
    cursor: pointer;
    color:black;
  }
  .delete{
    border-radius: 3px;
    padding: 3px 2px 4px 3px;
  }
  .edit{
    border-radius: 3px;
    padding: 3px 2px 4px 3px;
  }
  .evaluation_style{
    transition: height 0.5s;
    background: #F8F8F8;
    cursor: default;
    border: 0;
    padding: 15px;
    height: 50px;
    color: #464444;
    vertical-align: middle;
    margin-left: 2px;
    margin-right: 2px;
    margin-bottom: 12px;
  }
  .circle{
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin-right: 4px;
    display: inline-block;
    color:#13DA7C;
    background-color:#13DA7C;
  }
  .img{
    padding: 2px 8px 2px 5px;
  }
.circle1{
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin-right: 4px;
    display: inline-block;
    color:#F8D21C;
    background-color:#F8D21C;
  }
  .circle2{
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin-right: 4px;
    display: inline-block;
    color:#FF5257;
    background-color:#FF5257;
  }
  .evaluation_empty{
    margin-top: 14%;
    text-align: center;
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
  .span-color{
    background: #FED4DE;
    color: #DD3D64;
    border-radius: 10px;
    padding: 0px 9px;
    font-weight: 600;
  }
   .header{
    margin: 0;
    display: inline-block;
    font-weight: 700;
    color: #143361;
    line-height: 30px;
    margin-left: 14px;
    margin-right: 4px;
}

.generate{
  margin-right: 20px;
}
.fileName{
  max-width: 200px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
  }
.attachments-view
{
  margin-top: 5px;
  /* color:#4A90E2; */
  margin-left: 0px;
  border: 1px solid #4A90E2 !important;
  background: #e6eff9  !important;
  padding: 1px 10px;
  display: inline-block;
  border-radius: 30px;
  font-weight: bold;
  float: left;
  margin-right: 2%;
}
 .editDisable{
    cursor: not-allowed !important;
    color: #00000057 !important;
  }
  .evaluation_details_label{
    font-weight:500;
    color:#57575B;
  }
  .evalution_details_values{
    font-weight:600;
    color:#4E5254;
  }
  .project_title{
    max-width: 170px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .cursorCls
  {
    cursor:not-allowed !important;
  }
  .hideShow
  {
    pointer-events: none !important;
  }
  .pms-review-header-section {
    display: flex;
    align-items: center;
    gap: 8px;
}

.inactive-header {
    color: #757575;
    font-weight: 400;
    cursor: pointer;
    font-size: 14px;
    line-height: 16px;
}

.active-header {
  color: #143361;
  border-bottom: 2px solid #143361;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  line-height: 16px;
}

.pms-header-title {
  text-align: center;
  padding: 12px;
}

.eval-top {
  margin-bottom: 10px;
  border-bottom: 1px solid #EEEEEE;
}

.loader-class {
    padding-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/Evaluation.vue